<template>
    <div class="xl:col-span-9 col-span-8 lg:mt-0 mt-10 articles">
        <article-item v-for="article in activeArticles" :article="article" :user="user" :key="article.id">
        </article-item>
        <load-more container=".articles" @ready="loadMore()"></load-more>
    </div>
</template>

<script>
import ArticleItem from './ArticleItem';
import LoadMore from './LoadMore';

export default {
    name: 'articles-tag',

    props: {
        tag: {
            type: Object,
            required: true,
        },
        articles: {
            type: Array,
            required: true,
        },
        paginated: {
            type: Boolean,
            required: false,
        },
        user: {
            type: Object,
            required: false,
        },
    },

    components: {
        ArticleItem,
        LoadMore,
    },

    data() {
        return {
            activeArticles: this.articles,
            isPaginated: this.paginated,
            perPage: 12,
        };
    },

    methods: {
        loadMore() {
            if (this.isPaginated) {
                this.load();
            }
        },

        load() {
            axios.get(`/revista/palabras/${this.tag.slug}?page=${this.page}`).then((response) => {
                this.activeArticles = this.activeArticles.concat(
                    response.data.data.filter((element) =>
                        this.activeArticles.every((displayed) => displayed.slug !== element.slug)
                    )
                );
                response.data.links.next ? (this.isPaginated = true) : (this.isPaginated = false);
            });
        },
    },

    computed: {
        page() {
            return Math.floor(this.activeArticles.length / this.perPage) + 1;
        },
    },
};
</script>
